var _module_exports = "<pr-page-margin-positioner>\n\t<pr-page-header-footer class=\"page-footer\" type=\"footer\"></pr-page-header-footer>\n</pr-page-margin-positioner>\n";;
var path = '/app/src/client/components/page/page-footer/page-footer.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;